import React from "react";
import LoadSpinner from "../../utilities/LoadSpinner";

// Shared by the secondary settings tabs; the main Settings workspace stays fluid.
export const settingsPageTitleClass = "text-2xl font-semibold text-slate-900";

export default function SettingsPageLayout({ children, className = "" }) {
  return (
    <div className={`min-h-screen w-full min-w-0 bg-slate-50 px-6 py-6 sm:px-4 ${className}`}>
      <div className="mx-auto w-full max-w-[1240px]">{children}</div>
    </div>
  );
}

export function SettingsPageLoading() {
  return (
    <SettingsPageLayout>
      <div role="status" aria-label="Loading settings" className="flex min-h-[320px] items-center justify-center">
        <LoadSpinner />
      </div>
    </SettingsPageLayout>
  );
}
